export default __webpack_public_path__ + "static/media/cexplorer-logo-mini.7db558d5.svg";